import { apiSlice } from "../../app/api/apiSlice";

export const getOBChangeRequestsApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getOBChangeRequests: builder.mutation({
			query: (body) => ({
				url: "/api/v1/loan/get_ob_change_requests/",
				method: "POST",
				body: body,
			}),
		}),
	}),
});

export const { useGetOBChangeRequestsMutation } = getOBChangeRequestsApiSlice;
